import Image from "next/image";

export const DynamicImage = (
  src: string,
  alt: string,
  width?: number,
  height?: number
) => <Image width={width || 15} height={height || 15} src={src} alt={alt} />;
